/**
 * FeeManagement Component
 * 협력사 → 본사 수수료 관리
 * 본사가 협력사에게 설정하는 수수료 (일정산/주정산)
 */
import React from 'react';
import Loading from '@/shared/components/feedback/Loading';
import FilterSection from './FilterSection';
import CommissionTable from './CommissionTable';
import SharedHistoryModal from '../../shared/components/HistoryModal';
import FeeApplyDateModal from '../../shared/components/FeeApplyDateModal';
import { useFeeManagementData } from '../hooks/useFeeManagementData';
import '@/shared/styles/common-table.css';

const FeeManagement: React.FC = () => {
    const {
        loading,
        commissionData,
        supplierNames,
        partnerId,
        setPartnerId,
        statusFilter,
        setStatusFilter,
        showHistoryModal,
        setShowHistoryModal,
        selectedSupplier,
        historyData,
        showFeeApplyModal,
        setShowFeeApplyModal,
        feeApplyDateInfo,
        setFeeApplyDateInfo,
        currentPage,
        totalPages,
        currentItems,
        goToPage,
        handleSearch,
        handleQuickFilter,
        handleSetDefaultValues,
        handleSetDefaultPayback,
        handleToggleFeeChange,
        handleNewCommissionTypeChange,
        handleNewAmountChange,
        handleNewStartDateChange,
        handleNewPaybackUseYnChange,
        handleNewPaybackAmountChange,
        handleSave,
        handleSaveAll,
        handleShowHistory,
    } = useFeeManagementData();

    if (loading) {
        return <Loading message="수수료 데이터를 불러오는 중..." />;
    }

    return (
        <div className="supplier-selection-page">
            {/* 필터 섹션 */}
            <FilterSection
                partnerId={partnerId}
                supplierNames={supplierNames}
                statusFilter={statusFilter}
                onPartnerChange={setPartnerId}
                onStatusChange={setStatusFilter}
                onSearch={handleSearch}
                onQuickFilter={handleQuickFilter}
            />

            {/* 협력사 수 + 일괄 액션 버튼 */}
            <div className="result-count">
                <span>
                    <i className="fas fa-list"></i>
                    총 <strong>{commissionData.length.toLocaleString()}개</strong> 협력사
                </span>
                <div style={{ marginLeft: 'auto', display: 'flex', gap: '6px', alignItems: 'center' }}>
                    <button
                        className="btn btn-secondary"
                        style={{ fontSize: '0.85rem', padding: '5px 12px' }}
                        onClick={handleSetDefaultValues}
                        title="모든 협력사에 초기값을 일괄 설정합니다"
                    >
                        <i className="fas fa-magic"></i>
                        <span style={{ marginLeft: '4px' }}>전체 초기값 설정</span>
                    </button>
                    <button
                        className="btn btn-secondary"
                        style={{ fontSize: '0.85rem', padding: '5px 12px' }}
                        onClick={handleSetDefaultPayback}
                        title="모든 협력사에 페이백 초기값(30원)을 일괄 설정합니다"
                    >
                        <i className="fas fa-magic"></i>
                        <span style={{ marginLeft: '4px' }}>페이백 초기값(30원)</span>
                    </button>
                    <button
                        className="btn btn-primary"
                        style={{ fontSize: '0.85rem', padding: '5px 12px' }}
                        onClick={handleSaveAll}
                        title="변경된 모든 협력사 수수료를 일괄 저장합니다"
                    >
                        <i className="fas fa-save" style={{ color: '#fff' }}></i>
                        <span style={{ marginLeft: '4px' }}>전체 저장</span>
                    </button>
                </div>
            </div>

            {/* 수수료 테이블 */}
            <CommissionTable
                currentItems={currentItems}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={goToPage}
                onNewCommissionTypeChange={handleNewCommissionTypeChange}
                onNewAmountChange={handleNewAmountChange}
                onNewPaybackUseYnChange={handleNewPaybackUseYnChange}
                onNewPaybackAmountChange={handleNewPaybackAmountChange}
                onNewStartDateChange={handleNewStartDateChange}
                onShowHistory={handleShowHistory}
                onSave={handleSave}
                onToggleFeeChange={handleToggleFeeChange}
            />

            {/* 히스토리 모달 */}
            <SharedHistoryModal
                isOpen={showHistoryModal}
                title="수수료 변경 이력"
                name={selectedSupplier}
                historyData={historyData}
                onClose={() => setShowHistoryModal(false)}
                showPeriodColumn={true}
            />

            {/* 수수료 적용 예정일 모달 */}
            {feeApplyDateInfo && (
                <FeeApplyDateModal
                    isOpen={showFeeApplyModal}
                    applyStartDate={feeApplyDateInfo.applyStartDate}
                    isImmediateApply={feeApplyDateInfo.isImmediateApply}
                    onClose={() => {
                        setShowFeeApplyModal(false);
                        setFeeApplyDateInfo(null);
                    }}
                />
            )}
        </div>
    );
};

export default FeeManagement;
